<template>
  <section
    class="case-study-hero"
    :style="{
      backgroundImage: `
        url(${$baseUrl}images/case-${route.query.caseStudy}.webp)
        `,
    }"
  >
  <Breadcrumb v-if="tvaMq !== 'mobile'"/>
    <div class="case-study-hero__left">
      <h1 class="case-study-hero__left__title">
        {{ title }}
      </h1>
      <ButtonScroll class="case-study-hero__scroll-down-btn" v-if="tvaMq !== 'mobile'"/>
    </div>
  </section>
</template>

<script setup>
import { inject } from "vue";
import { useRoute } from "vue-router";

import Breadcrumb from "@/components/molecules/Breadcrumb.vue";
import ButtonScroll from "../atoms/ButtonScroll.vue";

const tvaMq = inject("$tvaMq");

defineProps({
  title: String,
});

const $baseUrl = inject("$baseUrl");
const route = useRoute();
</script>

<style lang="scss" scoped>
.case-study-hero {
  --page-padding-h-final: calc(
    var(--page-padding-h) + var(--page-padding-h-offset)
  );

  width: 100%;
  height: calc(var(--vh) * 100);
  background-size: cover;
  color: var(--color-white);
  position: relative;

  &__left {
    background: var(--background-bg-blurr-dark);
    backdrop-filter: blur(toRem(25));

    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;

    .desktop &,
    .large & {
      width: max(39.7vw, toRem(400));
      height: 100%;
      padding: 0 2rem 0 var(--page-padding-h-final);
    }

    .mobile &,
    .tablet & {
      border-top: 0.5px solid var(--color-white);
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 0 var(--page-padding-h-final);
      .button-scroll {
        align-self: flex-start;
      }
    }

    .tablet & {
      height: 40%;
      padding-top: toRem(48);
    }

    .mobile & {
      height: 30%;
      padding-top: calc(var(--vh) * 5);
    }

    &__title {
      .desktop &,
      .large &,
      .tablet & {
        @include header-h-1;
        margin-top: 30vh;
      }

      .tablet & {
        margin-top: 0;
      }

      .mobile & {
        margin-top: 0;
        @include header-h-2;

        line-height: 105%;
      }

      margin-bottom: 0.25rem;
    }
  }
}
</style>
